export { default } from './SlaughterList';
